<template>
    <!-- Modal backdrop. This what you want to place close to the closing body tag -->
    <div
        v-if="isModalOpen"
        class="fixed inset-0 z-30 flex items-end bg-black bg-opacity-50 sm:items-center sm:justify-center p-10"
    >
        <!-- Modal -->
        <div
            class="w-1/3 flex flex-col overflow-hidden bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4"
            role="dialog"
            id="modal"
        >
            <!-- Modal body -->
            <div class="px-6 py-4 border-b dark:border-gray-500 flex justify-between items-center">
                <p class="text-lg font-semibold text-gray-700 dark:text-gray-300">Save Block to library</p>
                <button type="button" @click.prevent="close" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="mb-6 overflow-auto h-full">
                <div class="px-6 py-4 h-full">
                    <div class="p-3 h-full">
                        <form @submit.prevent="save">
                            <div class="px-4 py-5 sm:p-6 shadow sm:rounded-md">
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <jet-label for="name" value="Name"/>
                                        <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" required
                                                   :error="!!form.errors.name"
                                                   autofocus/>
                                        <jet-input-error :message="form.errors.name"/>
                                    </div>
                                    <div class="col-span-6">
                                        <jet-label for="preview_image" value="Preview"/>
                                        <jet-input id="preview_image"
                                                   type="file"
                                                   @change.prevent="fileSelected"
                                                   class="mt-1 block w-full"
                                                   accept="image/*"
                                                   :error="!!form.errors.preview_image"
                                        />
                                        <jet-input-error :message="form.errors.preview_image"/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <footer
                class="flex flex-col items-center justify-end px-6 py-3 sm:flex-row bg-gray-50 dark:bg-gray-700"
            >
                <jet-button
                    @click.prevent="save"
                    type="button"
                    class="mr-2 w-full px-5 py-3 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg sm:w-auto sm:px-4 sm:py-2 active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                >
                    Save
                </jet-button>
                <jet-button
                    @click.prevent="close"
                    type="button"
                    class="w-full px-5 py-3 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg sm:w-auto sm:px-4 sm:py-2 active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                >
                    Cancel
                </jet-button>
            </footer>
        </div>
    </div>
    <!-- End of modal backdrop -->
</template>

<script>
import JetButton from '@/Jetstream/Button';
import {useForm} from "@inertiajs/inertia-vue3";
import QuoteBlockForm from "@/Pages/Admin/QuoteBlock/Partials/QuoteBlockForm";
import JetInput from "@/Jetstream/Input";
import JetLabel from "@/Jetstream/Label";
import JetInputError from "@/Jetstream/InputError";
import {inject} from "vue";

export default {
    components: {
        JetInput,
        JetLabel,
        QuoteBlockForm,
        JetButton,
        JetInputError,
    },
    props: {
        isModalOpen: {
            type: Boolean,
            default: false,
        },
        sourceBlockTypeElement: {
            type: Object,
            required: true,
        },
        quote: {
            type: Object,
            required: true,
        }
    },
    setup(props, {emit}) {
        const form = useForm({
            name: null,
            quote_block_type_source_folder_name: props.sourceBlockTypeElement?.quote_block_type_source_folder_name
                ?? props.sourceBlockTypeElement?.source_folder_name,
            html: props.sourceBlockTypeElement?.html,
            quoteId: props.quote.id,
            sourceBlockUuid: props.sourceBlockTypeElement.uuid,
            preview_image: null,
        });

        const fileSelected = (event) => {
            form.preview_image = event.target.files[0];
        }

        const close = () => {
            emit("close");
        };

        const $toast = inject('$toast');

        const save = () => {
            form.post(route('admin.quote-block.store'), {
                forceFormData: true,
                onSuccess: () => {
                    close();
                    $toast('Block saved.', {
                        type: 'success',
                    })
                }
            });
        }

        return {
            form,
            close,
            save,
            fileSelected,
        }

    },
}
</script>

<style scoped>

</style>
